import React from 'react'
import Wave from 'react-wavify'
import { Action, async, AsyncState, IOWidget, loadingAsyncState, mk_widget } from 'widgets-for-react'
import { CMSState } from '../../../../cms/blocks/types.gen'
import { PublicSite_CustomPageData } from '../../../application.mod'
import { WordPress } from '../../../../wordpress/wordpress_api'
import { enableReducedMotion } from '../../../custom_pages/Fc150YearsWidget/Fc150Years.utils'
import { PublicSiteState } from '../../../../public_site.main.mod'
import { NavLink } from 'react-router-dom'
import { BackButton } from './backButton'
import InView from 'react-intersection-observer'
import { getImageAttribute } from '../../../utils/extra_images.mod'
import { get_stories_by_ids } from '../../../custom_pages/Fc150YearsWidget/Fc150Years.api'
import { Map } from 'immutable'


export type MoreStoriesBlockProps = {
  prev_story: number
  next_story: number
  show_next: boolean
  show_prev: boolean
  isInview: boolean
  block_index: number
  related_stories: AsyncState<Map<number, WordPress.StoryResponse>>
}

export type MoreStoriesBlockStyle = Partial<{
  block_classname: string
  inner_classname: string
  header_classname: string
  title_classname: string
  content_classname: string
  text_classname: string
  footer_classname: string
  clickable_primary_classname: string
  clickable_secondary_classname: string
}>

export function MoreStoriesBlock<CustomBlockData, extra_images>(
  props: MoreStoriesBlockProps,
  options?: { style?: MoreStoriesBlockStyle; key?: string }
): (s: CMSState<CustomBlockData, extra_images, PublicSite_CustomPageData>) => IOWidget<PublicSiteState, Action<CMSState<CustomBlockData, extra_images, PublicSite_CustomPageData>>> {
  return (s: CMSState<CustomBlockData, extra_images, PublicSite_CustomPageData>) => (public_state: PublicSiteState) =>
    mk_widget({
      run: setState => {

        const setBlockState = <K extends keyof MoreStoriesBlockProps>(prop: K, newValue: MoreStoriesBlockProps[K]) => (s: CMSState<CustomBlockData, extra_images, PublicSite_CustomPageData>): CMSState<CustomBlockData, extra_images, PublicSite_CustomPageData> => {
          if (!s.blocks.has(props.block_index)) return s
          let current_block = s.blocks.get(props.block_index) as any//as CustomBlockData
          if (current_block.kind != 'moreStoriesBlock') return s
          current_block = ({
            ...current_block,
            value: {
              ...current_block.value,
              fst: {
                ...current_block.value.fst,
                [prop]: newValue
              },

            }
          })
          return ({ ...s, blocks: s.blocks.set(props.block_index, current_block) })
        }

        let story: WordPress.PageResponse & WordPress.EmbedData = undefined
        let taxonomy: WordPress.TaxonomyResponse = undefined
        if (public_state.Fc150YearsMainPage.state.page.page.kind == 'loaded') {
          story = public_state.Fc150YearsMainPage.state.page.page.value as unknown as WordPress.PageResponse & WordPress.EmbedData
          if (story != undefined && story._embedded != undefined && story._embedded['wp:term'] != undefined) {
            taxonomy = story._embedded['wp:term'].length > 0 ? story._embedded['wp:term'][0].length > 0 ? story._embedded['wp:term'][0][0] : undefined : undefined
          }
        }


        // let overviewPage: WordPress.PageResponse & WordPress.EmbedData = undefined
        // if (public_state.Fc150YearsMainPage.pagesloader.kind == 'loaded') {
        //   overviewPage = public_state.Fc150YearsMainPage.pagesloader.value.find(page => page.categories.includes(taxonomy?.id))
        // }

        // let overviewPage_slug = overviewPage != undefined ? overviewPage.slug : public_state.Fc150YearsMainPage.storyDetailState.overview_title

        let isInview: boolean = props.isInview;
        let wavePaused: boolean = enableReducedMotion;
        if (!isInview) {
          wavePaused = true;
        }

        // Add this piece code again if the clients wants the only selected story to appear on the right of the screen. This swaps the story position if only story 1 is set to the right.
        // if ((props.prev_story != undefined && props.next_story == undefined) || (props.show_prev && !props.show_next)) {
        //   props.next_story = props.prev_story
        //   props.show_next = props.show_prev
        //   props.prev_story = undefined
        //   props.show_prev = false
        // }

        let story_ids: number[] = []
        if (props.next_story) {
          story_ids.push(props.next_story)
        }
        if (props.prev_story) {
          story_ids.push(props.prev_story)
        }
        if (props.related_stories.kind == 'unloaded') {
          setState(setBlockState('related_stories', loadingAsyncState(() => get_stories_by_ids(public_state.Fc150YearsMainPage.lang, story_ids))))
        }


        return (
          <>
            {async<Map<number, WordPress.StoryResponse>>()(props.related_stories).run(a => setState(setBlockState('related_stories', a(props.related_stories))))}

            <InView className="page__related" as='div' key={`more-${isInview}`} onChange={(inView) => setState(setBlockState('isInview', inView))}>
              <div className="related__wrap grid--gutter container--xl">
                <div className="related__first">
                  {(props.show_prev && props.prev_story && props.related_stories.kind == 'loaded' && props.related_stories.value.has(props.prev_story) && props.related_stories.value.get(props.prev_story).categories.includes(taxonomy?.id)) && (
                    <div className="related__item">
                      <NavLink to={`${"/" + public_state.Fc150YearsMainPage.lang}/${taxonomy?.slug}/${props.related_stories.value.get(props.prev_story).slug}`} className="related__itemlink">
                        <div className="related__itemcontent">
                          <h2 className="related__itemtitle typo--s">{props.related_stories.value.get(props.prev_story).title.rendered}</h2>
                        </div>
                        <div className="portrait portrait--large portrait--related">
                          <div className="portrait__inner">
                            {props.related_stories.value.get(props.prev_story).featured_media_object && props.related_stories.value.get(props.prev_story).featured_media_object.source_url &&
                              <div className="portrait__visual">
                                <img className="portrait__image lazyload" width="400" height="400" alt=""
                                  src="/frontend/images/empty.png"
                                  data-src={getImageAttribute(props.related_stories.value.get(props.prev_story)?.featured_media_object, 'portrait_m', 'source_url')}
                                  data-srcset={`${getImageAttribute(props.related_stories.value.get(props.prev_story)?.featured_media_object, 'portrait_m', 'source_url')} 400w, ${getImageAttribute(props.related_stories.value.get(props.prev_story)?.featured_media_object, 'portrait_xl', 'source_url')} 800w`}
                                  data-sizes="auto"
                                />
                              </div>
                            }
                          </div>
                        </div>
                      </NavLink>
                    </div>
                  )}
                </div>
                <div className="related__return">
                  <NavLink to={`${"/" + public_state.Fc150YearsMainPage.lang}/${taxonomy?.slug}/?taxonomy=${taxonomy?.id}`} className="related__returnlink">
                    <div className="related__returntext">
                      <div dangerouslySetInnerHTML={{ __html: BackButton }} />
                      <p className="related__returnlabel typo--3xs">back to {taxonomy?.name}</p>
                    </div>
                    <div className="themeicon themeicon--l related__themevisual" aria-hidden="true">
                      <div className="themeicon__icon related__themeicon">
                        <img className="themeicon__bg related__themebg lazyload" width="320" height="180" alt=""
                          src="/frontend/images/empty.png"
                          data-src={`/frontend/images/themes/bg--${taxonomy?.slug}-640w.jpg`}
                        />
                      </div>
                    </div>
                  </NavLink>

                  <div className="related__waves" aria-hidden="true">
                    <Wave fill="rgb(255, 255, 255, 0)" stroke='rgb(255, 255, 255, .1)'
                      paused={wavePaused} // PAUSED WHEN NOT IN VIEW!
                      options={{
                        height: 60,
                        amplitude: 40,
                        speed: 0.1,
                        points: 8
                      }}
                      className="related__wave"
                    />
                    <Wave fill="rgb(255, 255, 255, 0)" stroke='rgb(255, 255, 255, .2)'
                      paused={wavePaused} // PAUSED WHEN NOT IN VIEW!
                      options={{
                        height: 60,
                        amplitude: 40,
                        speed: 0.1,
                        points: 5
                      }}
                      className="related__wave"
                    />
                    <Wave fill="rgb(255, 255, 255, 0)" stroke='rgb(255, 255, 255, 0.25)'
                      paused={wavePaused} // PAUSED WHEN NOT IN VIEW!
                      options={{
                        height: 60,
                        amplitude: 40,
                        speed: 0.1,
                        points: 6
                      }}
                      className="related__wave"
                    />
                  </div>
                </div>
                <div className="related__second">
                  {(props.show_next && props.next_story && props.related_stories.kind == 'loaded' && props.related_stories.value.has(props.next_story) && props.related_stories.value.get(props.next_story).categories.includes(taxonomy?.id)) && (
                    <div className="related__item">
                      <NavLink to={`${"/" + public_state.Fc150YearsMainPage.lang}/${taxonomy?.slug}/${props.related_stories.value.get(props.next_story).slug}`} className="related__itemlink">
                        <div className="related__itemcontent">
                          <h2 className="related__itemtitle typo--s">{props.related_stories.value.get(props.next_story).title.rendered}</h2>
                        </div>
                        <div className="portrait portrait--large portrait--related">
                          <div className="portrait__inner">
                            {props.related_stories.value.get(props.next_story).featured_media_object && props.related_stories.value.get(props.next_story).featured_media_object.source_url &&
                              <div className="portrait__visual">
                                <img className="portrait__image lazyload" width="400" height="400" alt=""
                                  src="/frontend/images/empty.png"
                                  data-src={getImageAttribute(props.related_stories.value.get(props.next_story)?.featured_media_object, 'portrait_m', 'source_url')}
                                  data-srcset={`${getImageAttribute(props.related_stories.value.get(props.next_story)?.featured_media_object, 'portrait_m', 'source_url')} 400w, ${getImageAttribute(props.related_stories.value.get(props.next_story)?.featured_media_object, 'portrait_xl', 'source_url')} 800w`}
                                  data-sizes="auto"
                                />
                              </div>
                            }
                          </div>
                        </div>
                      </NavLink>
                    </div>
                  )}
                </div>
              </div>
            </InView>
          </>
        )
      }
    })
}

